import { hgetRequest, hpostRequest } from '../../util/htools.axios';

/*
 *@Description: 管理员角色列表
 *@MethodAuthor:  myw
 *@Date: 2020-12-04 11:36:01
 */
export const adminRoleListService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				pageNum: 0,
				pageSize: 0,
				roleName: '',
				...data
			};
			const res = await hpostRequest('hlxpeng/role/roleAllQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
			/* reject(error); */
		}
	});
};
/*
 *@Description: 查询所有不属于任何企业的角色
 *@ClassAuthor: Happy ZXM
 *@Date: 2021-01-22 11:12:17
 */
export const adminRoleAdminListService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hpostRequest('hlxpeng/role/roleByAllQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
			/* reject(error); */
		}
	});
};
/*
 *@Description: 管理员角色添加
 *@MethodAuthor:  myw
 *@Date: 2020-12-04 11:36:10
 */
export const adminRoleAddService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				roleName: '',
				state: 0,
				des: '',
				...data
			};
			const res = await hpostRequest('hlxpeng/role/roleAdd', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
			/* reject(error); */
		}
	});
};
/*
 *@Description: 管理员角色编辑
 *@MethodAuthor:  myw
 *@Date: 2020-12-04 14:01:46
 */
export const adminRoleEditService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				roleName: '',
				state: 0,
				des: '',
				...data
			};
			if (dataJson.organizationId === 0) {
				dataJson.organizationId = null;
			} else {
				dataJson.organizationId = data.organizationId;
			}
			const res = await hpostRequest('hlxpeng/role/roleUpdate', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
			/* reject(error); */
		}
	});
};
/*
 *@Description: 管理员角色删除
 *@MethodAuthor:  myw
 *@Date: 2020-12-04 14:40:48
 */
export const adminRoleDeleteService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				ids: [],
				...data
			};
			const res = await hpostRequest('hlxpeng/role/roleDel', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
			/* reject(error); */
		}
	});
};
/*
 *@Description: 管理员角色赋权限
 *@MethodAuthor:  myw
 *@Date: 2020-12-09 14:49:46
 */
export const adminRoleAuthorizeService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				roleId: '',
				powers: [],
				...data
			};
			const res = await hpostRequest('hlxpeng/role/roleConfigure', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 管理员角色详情
 *@MethodAuthor:  myw
 *@Date: 2020-12-11 09:17:20
 */
export const adminRoleDetailService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				roleId: '',
				...data
			};
			const res = await hgetRequest('hlxpeng/role/roleByIdQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};

export default adminRoleListService;
